import React from "react";

const Blog = ({ heading, date, index, image, description }) => {
  return (
    <div className="flex flex-col  gap-5 justify-start items-start" key={index}>
      {image && (
        <img
          src={image}
          className={` rounded-lg shadow-lg
      ${
        heading === "Using EdTech to Close Education Gaps"
          ? "md:h-[900px] object-cover"
          : ""
      }`}
          alt="Blogimage"
        />
      )}

      <p className="font-light dark:text-white text-gray-700 text-lg ">
        {date}
      </p>
      <h1 className="text-xl dark:text-orange-400 font-semibold  font-sans  text-black leading-normal">
        {heading}
      </h1>
      <p className=" text-gray-700 dark:text-dimWhite text-lg font-medium">
        {description}
      </p>
      <button className="text-[#4f1951] dark:text-light dark:border-light hover:dark:text-dark hover:dark:bg-light border-[1px] border-[#4f1951] duration-300 hover:scale-110 hover:text-white px-5 py-2  rounded-lg  self-start hover:bg-[#4f1951]">
        Read more
      </button>
      <div className="h-[1px] w-full border-[1px] dark:border-white border-black mt-5 text-black"></div>
    </div>
  );
};

export default Blog;
